<template>
  <div class='h-dialogContainer h-alarm-filter'>
    <div class='row h-row-around-inputBox'>
      
      <div class='col-sm-6'>
        <!-- <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.alarmID')}}:</div>
          <ejs-textbox name='alarmID' v-model='conditions.alarmID' :placeholder='$t("Alarm.alarmID")'></ejs-textbox>
        </div>
        <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.alarmName')}}:</div>
          <ejs-textbox name='alarmName' v-model='alarmName' :placeholder='$t("Alarm.alarmName")'></ejs-textbox>
        </div> -->
        <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.validityTime')}}:</div>
          <ejs-daterangepicker  :format='dateFormat' ref="datePicker" v-model='createTime'></ejs-daterangepicker>
        </div>
        <!-- <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.clearTime')}}:</div>
          <ejs-daterangepicker :format='dateFormat' v-model='clearTime'></ejs-daterangepicker>
        </div> -->
        <!-- <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.confirmTime')}}:</div>
          <ejs-daterangepicker :format='dateFormat' v-model='confirmTime'></ejs-daterangepicker>
        </div> -->
        <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.eqType')}}:</div>
          <ejs-dropdownlist :dataSource='typeList' :placeholder='listPlaceholder' :fields='clearFields' v-model='type'></ejs-dropdownlist>
        </div> 
        <div   class='h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.subnetName')}}:</div>
          <ejs-dropdownlist :dataSource='subnetList' :placeholder='listPlaceholder' :fields='subnetFields' v-model='subnetId'></ejs-dropdownlist>
        </div> 
        <!-- <div v-if='hasStatus' class='h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.clearState')}}:</div>
          <ejs-dropdownlist :dataSource='clearStatus' :placeholder='listPlaceholder' :fields='clearFields' v-model='conditions.alarmState.clearState'></ejs-dropdownlist>
        </div> -->
        <!-- <div v-if='hasStatus' class='h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.confirmState')}}:</div>
          <ejs-dropdownlist :dataSource='confirmStatus' :placeholder='listPlaceholder' :fields='clearFields' v-model='conditions.alarmState.confirmState'></ejs-dropdownlist>
        </div> -->
        <!-- <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.isvirtual')}}:</div>
          <ejs-dropdownlist :dataSource='nodeVMwareFlag' :placeholder='listPlaceholder' :fields='clearFields' v-model='conditions.nodeVMwareFlag'></ejs-dropdownlist>
        </div> -->
        <!-- <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.alarmLevel')}}:</div>
          <div class='row' id='alarmLevelBox'>
            <div v-for='(alarm, index) in alarmLevelList' :key='index' class='col-sm-3 nopadding'>
              <ejs-checkbox :label='alarm.label' :value='alarm.value' :checked='alarm.checked'></ejs-checkbox>
            </div>
          </div>
        </div> -->
        <!-- <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{$t('Alarm.alarmType')}}:</div>
          <div class='row' id='alarmTypeBox'>
            <div v-for='(alarm, index) in alarmTypeList' :key='index' class='col-sm-6 nopadding3'>
              <ejs-checkbox :label='alarm.label' :value='alarm.value' :checked='alarm.checked'></ejs-checkbox>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class='h-clear-rowMg'></div>
  </div>
</template>
<script>
import TopoTree from '../../topoconfig/TopoTree';
export default {
  name: 'LicFilter',
  components: {
    TopoTree
  },
  props: {
    hasStatus: { type: Boolean, default: false },
    url: { type: String, default: '' }
  },
  data() {
    return {
            dateFormat: 'yyyy-MM-dd',
listPlaceholder: this.$t('Common.all'),
      clearFields: {
        text: 'name',
        value: 'code'
      },
        subnetFields: {
        text: 'name',
        value: 'id'
      },
        createTime: '',
        clearTime: '',
        confirmTime: '',
        
        typeList:[
          { name: this.$t('Alarm.eqType_1'), code: '1' },
        { name: this.$t('Alarm.eqType_2'), code: '2' },
        { name: this.$t('Alarm.eqType_4'), code: '4' }
        ],
        type:'',
        subnetId:'',
        alarmID: '',
        alarmName: '',
        nodeVMwareFlag: '',
        alarmLevel: [],
        alarmType: [],
        ne: [],
        flag: true,
        startTimeLong:'',
        endTimeLong:'',
      subnetList:[]
    }
  },
  methods:{
    exportExcel(){
      let paramstring = "?test=1"
     
      
      if (this.subnetId != "") {
        paramstring += "&subnetId=" + this.subnetId;
      }

      if (this.type != "") {
        paramstring += "&type=" + this.type;
      }
      if(this.$refs.datePicker.ej2Instances.startDate != null){
         this.startTimeLong = this.$refs.datePicker.ej2Instances.startDate.getTime();
        this.endTimeLong = this.$refs.datePicker.ej2Instances.endDate.getTime()+24*60*60*1000-1;
       paramstring +=
        "&startTimeLong=" +
        this.startTimeLong +
        "&endTimeLong=" +
        this.endTimeLong;
      }
     console.log('条件',paramstring)
              
       
      // 保存下载导出表格
      let link = document.createElement('a');
      link.style.display = 'none';
      link.href = this.url + paramstring;
      document.body.appendChild(link);
      link.click();
    //   this.$axios.get(this.url).then((response) => {
      
    //   if (response && response.status === 200) {
        
    //   }
    // });
    },
    init(){
      
      this.axios.post('/lte/ems/topo/subnet/findAllSubnet').then(response => {
            if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
              if (response.data.resultVal && response.data.resultVal.length > 0) {
                this.subnetList = response.data.resultVal;
                console.log('查询全部子网数据!',this.subnetList)
              }
            } else {
              console.log('查询全部子网异常!');
            }
          });
    }
  },
  mounted() {
      this.init();
  }
};
</script>
